import axios from "axios"

export default {
    state: {
        hcmcReports: [],

        pendingHcmcReports: [],
        submittedHcmcReports: [],

        pendingHcmcCreditInstitutes: [],
        pendingPeriods: [],

        submittedHcmcCreditInstitutes: [],
        submittedPeriods: [],

        alertItems: {},


        currentHcmcReport: null,
        currentHcmcReportVersion: {},
    },

    getters: {
        currentHcmcReportDate: state => new Date(state.currentHcmcReport.lastUploadedVersionDate).toLocaleDateString('el'),

    },

    mutations: {
        getHcmcReports(state, reports) {
            state.hcmcReports = reports
        },

        setCurrentHcmcReport(state, report) {
            state.currentHcmcReport = report
        },

        setPendingHcmcReports(state) {
            state.pendingHcmcReports = state.hcmcReports.filter(
                function (el) {
                    if (el.submissionStatus == 'submittedToHCMC' || el.submissionStatus == 'returnedByHCMC') {
                        return el
                    }
                }
            )

        },

        setSubmittedHcmcReports(state) {
            state.submittedHcmcReports = state.hcmcReports.filter(
                function (el) {
                    if (el.submissionStatus == 'submittedToESMA' || el.submissionStatus == 'acceptedByESMA' || el.submissionStatus == 'returnedByESMA') {
                        return el
                    }
                }
            )
        },

        setPendingHcmcCreditInstitutes(state) {
            state.pendingHcmcCreditInstitutes = state.pendingHcmcReports.map(el => {
                return {
                    text: el.creditInstituteName,
                    value: el.creditInstituteId
                }
            })

        },


        setPendingPeriods(state) {
            state.pendingPeriods = state.pendingHcmcReports.map(el => {
                return {
                    text: el.reportPeriodName,
                    value: el.reportPeriodId
                }
            })
        },


        setSubmittedHcmcCreditInstitutes(state) {
            state.submittedHcmcCreditInstitutes = state.submittedHcmcReports.map(el => {
                return {
                    text: el.creditInstituteName,
                    value: el.creditInstituteId
                }
            })

        },


        setSubmittedPeriods(state) {
            state.submittedPeriods = state.submittedHcmcReports.map(el => {
                return {
                    text: el.reportPeriodName,
                    value: el.reportPeriodId
                }
            })
        },

        setReminderAlert(state, items) {
            state.alertItems = items
        },

        setCurrentHcmcReportVersion(state, currentHcmcReportVersion) {
            console.log('store', currentHcmcReportVersion)
            state.currentHcmcReportVersion = currentHcmcReportVersion
        }


    },
    actions: {
        async getHcmcReports({ commit }, payload) {
            console.log('store', payload)
            try {
                const result = await axios.get(`${process.env.VUE_APP_BASE_URL}/HCMC/GetReports`, {
                    params: {
                        creditInstituteId: payload?.creditInstituteId,
                        reportPeriodId: payload?.reportPeriodId,
                        reportStatus: payload?.reportStatus,
                        fundId: payload?.fundId,
                        year: payload?.year,
                        LastOfCreditInstitute: payload?.lastOfCreditInstitute

                    }
                })

                commit('getHcmcReports', result.data.results)

            }
            catch (e) {
                throw e
            }
        },

        async sendReminder({ commit }, payload) {
            try {

                await axios.post(`${process.env.VUE_APP_BASE_URL}/hcmc/sendreminder`, payload.body)


            }
            catch (e) {

                console.log(e)

            }
        },

        async returnForCorrections({ dispatch, commit }, payload) {
            try {
                console.log('return for corrections', payload.filters)
                const result = await axios.post(`${process.env.VUE_APP_BASE_URL}/hcmc/requestcorrection`, payload.content)
                await dispatch('getHcmcReports', payload.filters)

                commit("toggleSnackbar", {
                    open: true,
                    color: "success",
                    text: "Η επιστροφή για διόρθωση ολοκληρώθηκε με επιτυχία!",
                });
            }

            catch (e) {
                commit("toggleSnackbar", {
                    open: true,
                    color: "error",
                    text: `${e.response.data.errorMessage}`,
                });
            }
        },

        async submitToEsma({ commit, dispatch }, payload) {
            try {
                await axios.post(`${process.env.VUE_APP_BASE_URL}/hcmc/SubmitToESMA`, payload.content)
                await dispatch('getHcmcReports', payload.filters)
                commit('setPendingHcmcReports')
                commit('setSubmittedHcmcReports')


                commit("toggleSnackbar", {
                    open: true,
                    color: "success",
                    text: "Η αποστολή της έκθεσης ολοκληρώθηκε με επιτυχία",
                });
            } catch (e) {
                console.log(e)
                commit("toggleSnackbar", {
                    open: true,
                    color: "error",
                    text: `${e.response.data.errorMessage}`,
                });
            }



        }
    }
}